import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Solutions } from "./components/solutions";
import { Pricing } from "./components/pricing";
import { Demo } from "./components/demo";
import { Contact } from "./components/contact";
import { Footer } from "./components/Footer";
import { TermsOfService } from "./components/TermsOfService";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { Helmet } from "react-helmet";
import "./App.css";

const HomePage = () => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Peak Risk Management",
    "url": "https://peakrmis.com/",
    "logo": "https://peakrmis.com/logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-800-555-5555",
      "contactType": "Customer Service",
      "areaServed": "IN",
      "availableLanguage": "English"
    }
  };

  return (
    <div>
      <Helmet>
        <title>Title:  Cloud-Based RMIS for Compliance & Reporting | Peak Risk</title>
        <meta name="description" content="Empower data-driven risk decisions with Peak Risk Management, a next-gen cloud-based RMIS for compliance, reporting, and enterprise risk.s" />
        <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <Navigation />
      <Header />
      <Features />
      <About />
      <Solutions />
      <Pricing />
      <Demo />
      <Contact />
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms-and-conditions" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
